import { render, staticRenderFns } from "./ChurnChurnedPredicted.vue?vue&type=template&id=6a28eb2b&scoped=true"
import script from "./ChurnChurnedPredicted.vue?vue&type=script&lang=ts"
export * from "./ChurnChurnedPredicted.vue?vue&type=script&lang=ts"
import style0 from "./ChurnChurnedPredicted.vue?vue&type=style&index=0&id=6a28eb2b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a28eb2b",
  null
  
)

export default component.exports